module.exports = __webpack_public_path__ + "media/images/application/template/cta_bread_01-1de1920ffcf25809411030c33e39bf67.svg";